import { useDeleteLocation } from "api/locations/service";
import { useGetLocations } from "api/locations/service";
import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";
import { getActiveColorStyle } from "../../../utils/colorUtils";

const Locations = ({ permission, activeColor = "secondary" }) => {
  const activeColorStyle = useMemo(() => getActiveColorStyle(activeColor), [activeColor]);
  
  const navigate = useNavigate();
  const { data: locationsData, isLoading } = useGetLocations();
  const deleteLocationMutation = useDeleteLocation();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const handleDeleteClick = (id) => {
    setSelectedDeleteId(id);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (selectedDeleteId) {
      deleteLocationMutation.mutate(selectedDeleteId, {
        onSuccess: () => {
          setDeleteModalOpen(false);
          setSelectedDeleteId(null);
        }
      });
    }
  };

  const handleCancelDelete = () => {
    setDeleteModalOpen(false);
    setSelectedDeleteId(null);
  };

  return (
    <div className="tab-content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <CardTitle tag="h4" style={{ margin: 0 }}>Inventory Locations</CardTitle>
                {permission?.inventory_parameters_locations_add && (
                <Button 
                  size="sm" 
                  style={{ ...activeColorStyle, color: 'white' }}
                  onClick={() => navigate('/locations/add')}
                >
                  Add Location
                </Button>
                )}
              </div>
            </CardHeader>
            <CardBody>
              {isLoading ? (
                <div>Loading...</div>
              ) : !locationsData || !locationsData.results || locationsData.results.length === 0 ? (
                <div>No locations found.</div>
              ) : (
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th >#</th>
                      <th className="text-left">Name</th>
                      <th>Description</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th>Status</th>
                      <th className="text-right"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {locationsData.results.map((loc, idx) => (
                      <tr 
                        key={loc.id}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            navigate(`/locations/edit/${loc.id}`);
                        }}
                      >
                        <td >{idx + 1}</td>
                        <td className="text-left">{loc.location_name}</td>
                        <td>{loc.location_description}</td>
                        <td>{loc.lat}</td>
                        <td>{loc.long}</td>
                        <td>{loc.location_status === 1 ? 'Active' : 'Inactive'}</td>
                        <td className="text-right">
                          <div className="actions-right">
                            {permission?.inventory_parameters_locations_edit && (
                            <Button
                              color="link"
                              size="sm"
                              className="btn-icon btn-link like table-edit-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/locations/edit/${loc.id}`);
                              }}
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                            )}
                            {permission?.inventory_parameters_locations_delete && (
                            <Button
                              color="link"
                              size="sm"
                              className="btn-icon btn-link like table-delete-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteClick(loc.documentId);
                              }}
                              disabled={deleteLocationMutation.isPending}
                            >
                              {deleteLocationMutation.isPending && selectedDeleteId === loc.documentId ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              ) : (
                                <i className="tim-icons icon-simple-remove" />
                              )}
                            </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={deleteModalOpen} toggle={handleCancelDelete}centered={false} style={{ marginTop: '100px' }}>
        <div className="modal-header justify-content-center">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleCancelDelete}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">Delete Location</h6>
        </div>
        <ModalBody className="text-center">
          <p>Are you sure you want to delete this location?</p>
        </ModalBody>
        <div className="modal-footer">
          <Button 
            color="secondary" 
            type="button" 
            onClick={handleCancelDelete}
            disabled={deleteLocationMutation.isPending}
          >
            Cancel
          </Button>
          <Button 
             style={{
              background: 'linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93)',
              backgroundImage: 'linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93)',
              borderColor: '#fd5d93',
              color: 'white'
          }}
            color="danger" 
            type="button" 
            onClick={handleConfirmDelete}
            disabled={deleteLocationMutation.isPending}
          >
            {deleteLocationMutation.isPending ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              'Yes, Delete'
            )}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default Locations; 